module.exports = __webpack_public_path__ + "img/align-center.885feda4.svg";